import { Spinner } from '@blueprintjs/core';
import React from 'react';

import cls from './AppLoader.module.css';

function AppLoader() {
  return (
    <div className={cls.container}>
      <img src="/retroscore-logo-800.png" alt="M1 RetroScore powered by CAS" width="400" />
      <Spinner />
    </div>
  );
}

export default AppLoader;
